
    import {Component, Vue} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {manufactoryApi, moduleApi} from "@/api/organization";
    import {rulesApi} from "@/api/rules";

    @Component({name: 'Sys_SourceManage'})
    export default class Home extends Vue {
        title = "资源管理";
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;
        form = {
            name: ""
        }

        editId = 0;
        setDialog = false;
        addform = {
            name: "",
            orderIndex: "",
            // pageType: "",
            des: "",
            iconBack: "",
            iconUrl: "",
        } as any
        rules = {
            name: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
            orderIndex: [{ required: true, message: '请输入排序', trigger: 'blur' }],
            orderIndex2: [{ required: true, message: '请输入排序', trigger: 'blur' }],
            // pageType: [{ required: true, message: '请输入资源类型', trigger: 'blur' }],
            des: [{ required: true, message: '请输入资源描述', trigger: 'blur' }],
            iconBack: [{ required: true, message: '请输入背景色', trigger: 'blur' }],
            iconUrl: [{ required: true, message: '请输入图片名', trigger: 'blur' }],
        }
        allSelected = [];
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        listForm = {
            //开展的检定/校准项目
            items : [],
            rules: {
                orderIndex: [{ required: true, message: '请输入排序', trigger: 'blur' }],
            }
        };

        created() {
            this.list();
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        list() {
            const params = {
                ...this.listParam,
                name: this.form.name
            }
            moduleApi.pageList(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listForm.items = rData
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        //0新增  1编辑 2查看  3删除  4跳转模块权限
        toDetail(type: number){
            this.resetAddform();
            const dataArr = this.allSelected as any;
            let id = 0;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2 || type == 4)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
            }
            this.editId = id;
            if(type == 4){
                this.$router.push("/sys/resource/"+id);
                return
            }
            if(id != 0){
                moduleApi.getOne({id: id}).then(r => {
                    if (r.data.result === 0) {
                        const rData = r.data.data;
                        this.addform = rData;
                    }
                })
            }
            this.setDialog = true;
        }
        resetAddform(){
            for(const l in this.addform){
                this.addform[l] = "";
            }
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        saveBtn() {
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    const params = this.addform as any;
                    let api;
                    if (this.editId) {
                        params.id = this.editId;
                        api = moduleApi.updateById(params)
                    }else{
                        api = moduleApi.add(params)
                    }
                    api.then(r => {
                        this.$message.success("保存成功");
                        this.setDialog = false;
                        this.list();
                    })
                }
            })
        }

        del(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                moduleApi.delete({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        handleClick(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
            this.refresh();
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }
        saveSort(){
            const list = [] as any;
            this.listForm.items.forEach((e:any)=>{
                list.push({
                    id: e.id,
                    orderIndex: e.orderIndex
                })
            })
            moduleApi.changeOrderIndex(list).then(r => {
                if (r.data.result === 0) {
                    this.$message.success("保存成功");
                }
            })
        }
    }
